import { render } from "./currencyIndex.vue?vue&type=template&id=6da8b817&scoped=true"
import script from "./currencyIndex.vue?vue&type=script&lang=js"
export * from "./currencyIndex.vue?vue&type=script&lang=js"

import "./currencyIndex.vue?vue&type=style&index=0&id=6da8b817&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da8b817"]])

export default __exports__